/**
 * Taking only the pathname, query string and hash from `path` is what keeps an untrusted path,
 * such as the login redirectUri, from reaching another host or a `javascript:` URL.
 */
export const resolvePathOnCurrentHost = (path: string, currentHref: string, resetParams: boolean): string => {
  const siteRoot = new URL('/', currentHref)

  let target: URL

  try {
    target = new URL(path, siteRoot)
  } catch {
    // a malformed path such as `http://` cannot be parsed, so treat it as the site root
    target = siteRoot
  }

  const nextUrl = new URL(resetParams ? siteRoot : currentHref)

  nextUrl.pathname = target.pathname

  if (target.search || target.hash) {
    nextUrl.search = target.search

    nextUrl.hash = target.hash
  }

  return nextUrl.toString()
}
